import { all, takeEvery, fork, call, put } from "redux-saga/effects";
import { slackMeetingStoreMappingService } from "@iso/services";
import actions from "./actions";

function* searchMappings() {
  yield takeEvery(actions.SEARCH_REQUEST, function* ({ payload }) {
    const { keyword, storeIds, active, page, size, resolve, reject } = payload;
    try {
      const response = yield call(slackMeetingStoreMappingService.search, {
        keyword,
        storeIds,
        active,
        page,
        size,
      });
      resolve && resolve(response);
      yield put({
        type: actions.SEARCH_SUCCESS,
        items: response?.items ?? [],
        total: response?.total ?? 0,
      });
    } catch (e) {
      yield put({ type: actions.SEARCH_ERROR, error: e });
      reject && reject(e);
    }
  });
}

function* getDetail() {
  yield takeEvery(actions.DETAIL_REQUEST, function* ({ payload }) {
    const { slackMeetingStoreMappingId, resolve, reject } = payload;
    try {
      const response = yield call(slackMeetingStoreMappingService.getDetail, {
        slackMeetingStoreMappingId,
      });
      resolve && resolve(response);
      yield put({ type: actions.DETAIL_SUCCESS, detail: response });
    } catch (e) {
      yield put({ type: actions.DETAIL_ERROR });
      reject && reject(e);
    }
  });
}

function* createMapping() {
  yield takeEvery(actions.CREATE_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(slackMeetingStoreMappingService.create, data);
      yield put({ type: actions.CREATE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.CREATE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* updateMapping() {
  yield takeEvery(actions.UPDATE_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(slackMeetingStoreMappingService.update, data);
      yield put({ type: actions.UPDATE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.UPDATE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

function* deleteMapping() {
  yield takeEvery(actions.DELETE_REQUEST, function* ({ payload }) {
    const { slackMeetingStoreMappingId, resolve, reject } = payload;
    try {
      const response = yield call(slackMeetingStoreMappingService.delete, {
        slackMeetingStoreMappingId,
      });
      yield put({ type: actions.DELETE_SUCCESS });
      resolve && resolve(response);
    } catch (error) {
      yield put({ type: actions.DELETE_ERROR, error: error.response });
      reject && reject(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchMappings),
    fork(getDetail),
    fork(createMapping),
    fork(updateMapping),
    fork(deleteMapping),
  ]);
}
